<div class="w-full h-full flex flex-col bg-[var(--p-surface-900)]">
  <div class="flex justify-between w-full h-[64px] items-center md:pl-[40px] pl-[20px] pr-[16px]">
    <img alt="toonsqaure-col" class="w-full max-w-[127px]" src="/images/common/toonsquare-logo-col.svg" />
    <div class="flex">
      <p-button
        (click)="appService.openLanguageMenu()"
        [styleClass]="'only-icon-transparent'"
        [style]="{ width: '48px', height: '48px', padding: '12px' }"
      >
        <img alt="menu" class="w-[24px]" src="/images/common/globe-outline.svg" />
      </p-button>
      <p-button
        (click)="appService.menuDrawer = false"
        [styleClass]="'only-icon-transparent'"
        [style]="{ width: '48px', height: '48px', padding: '12px' }"
      >
        <img alt="menu" class="w-[24px]" src="/images/common/close-outline.svg" />
      </p-button>
    </div>
  </div>
  <div class="flex flex-col py-[16px]">
    @for (menu of appService.menuItem; track menu.id) {
      <div
        class="md:pl-[40px] pl-[20px] pr-[16px] py-[16px] leading-6 text-[16px] font-medium text-[var(--p-surface-500)]"
        [class]="menu.id === appService.currentMenu ? 'text-white' : ''"
        (click)="scrollToMenuSection(menu.id)"
      >
        {{ menu.label }}
      </div>
    }
  </div>
</div>
